export default __webpack_public_path__ + "static/culture-header-bg-e7b221af871aede3bbec6e09360e5c8e.png";